module.exports = __webpack_public_path__ + "static/img/lizhi.ea93b50e.png";